import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { EmptyStateComponent, ItemComponent, ITagIcon, ListDetailComponent, TileComponent } from '@tecalisdev/infinity';
import { MasterService } from '../../../../../shared/services/master.service';
import {
	DocStatus,
	IOperationDocumentsDetail,
	IProcessDetailResponse,
	PROCESS_STATUS,
} from '../../../../../processes/models/processes.models';
import { IOperationDetailResponse } from '../../../../models/operations.models';
import { documentsCompareHasAnyTableRow } from '../../../../../shared/utils/documents-external-compare.util';
import { OperationDocumentsChecksCompareInfoComponent } from '../../../../../shared/components/operations/documents/operation-documents-checks-compare-info/operation-documents-checks-compare-info.component';
import { notAvailableLabel } from '../../../../../core/utils/utils';

@Component({
	selector: 'app-operation-detail-tabs-checks-documents',
	imports: [
		TranslatePipe,
		TileComponent,
		EmptyStateComponent,
		ItemComponent,
		ListDetailComponent,
		OperationDocumentsChecksCompareInfoComponent,
	],
	templateUrl: './operation-detail-tabs-checks-documents.component.html',
	styleUrl: './operation-detail-tabs-checks-documents.component.scss',
})
export class OperationDetailTabsChecksDocumentsComponent implements OnChanges {
	@Input() detail: IOperationDetailResponse;

	private trans = inject(TranslateService);
	public masterService = inject(MasterService);

	public docsData: IOperationDocumentsDetail | null = null;
	public hasRequirementsContent = false;
	public hasCompareContent = false;
	public checksDetailCompare: IProcessDetailResponse | null = null;

	public ngOnChanges(changes: SimpleChanges): void {
		if (!changes['detail']) return;
		this.docsData = this.detail?.data
			? (this.detail.data as unknown as IOperationDocumentsDetail)
			: null;
		const docs = this.docsData?.document ?? [];
		this.hasRequirementsContent = docs.length > 0;
		this.hasCompareContent = documentsCompareHasAnyTableRow(docs, this.docsData, this.trans);
		this.checksDetailCompare = this.buildChecksDetailCompare();
	}

	/** Misma semántica que `ChecksComponent.getTagIconItem` (proceso / Figma). */
	public getTagIconItem(state?: string): ITagIcon {
		if (state === DocStatus.OK || state === 'OK') {
			return { icon: 'icon-check', status: 'success', size: 'sm' };
		}
		return { icon: 'icon-alert', status: 'error', size: 'sm' };
	}

	public documentTypeLabel(doc: { type?: string }): string {
		if (!doc?.type) return notAvailableLabel(this.trans);
		const key = 'DOCS.' + doc.type;
		return this.masterService.hasTranslation(key) ? this.trans.instant(key) : doc.type;
	}

	private buildChecksDetailCompare(): IProcessDetailResponse | null {
		if (!this.docsData || !this.detail) {
			return null;
		}
		return {
			general: {
				profile: { uuid: '', alias: '' },
				sms: [],
				auth: '',
				company: '',
				company_uuid: '',
				location: [],
				devices: [],
				init_operation: '',
				total_time: 0,
				end_operation: '',
				validation: '',
			},
			process_uuid: this.detail.process_uuid ?? '',
			process_details: '',
			status_process: PROCESS_STATUS.OK,
			data: { DOCUMENTS: this.docsData } as IProcessDetailResponse['data'],
			locks: this.detail.locks,
		} as IProcessDetailResponse;
	}
}
